<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">确认投标记录</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 内容区 -->
        <div class="content-container" v-loading="loading">
            <!-- 开标记录头部信息 -->
            <div class="record-header">
                <div class="header-item">
                    <span class="label">开标参与人：</span>
                    <span class="value">{{ recordData.participants }}</span>
                </div>
                <div class="header-item">
                    <span class="label">开标时间：</span>
                    <span class="value">{{ formatDateTime(recordData.bidOpeningTime) }}</span>
                </div>
            </div>

            <!-- 开标记录内容 -->
            <div class="record-content">
                <div class="content-html" v-html="recordData.content"></div>
            </div>

            <!-- 签名区域 -->
            <div class="signature-section">
                <div class="signature-button">
                    <el-button type="primary" @click="handleSign" :disabled="signed">
                        {{ signed ? '已签名' : '签名确认' }}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import { getOpeningRecordDetail, signNot, getSignNot } from '@/api/modules/agent'
export default {
    name: 'ConfirmBidRecord',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',
            projectTitle: '',
            loading: false,
            signed: false,
            recordData: {
                bidSectionCode: '',
                participants: '',
                bidOpeningTime: '',
                submitType: 0,
                content: ''
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getOpeningRecordDetail()
        this.getSignNot()
    },
    methods: {
        // 获取开标记录接口
        getOpeningRecordDetail() {
            this.loading = true
            getOpeningRecordDetail(this.sectionCode).then(res => {
                if (res.code === 200 && res.data) {
                    this.recordData = {
                        bidSectionCode: res.data.bidSectionCode || '',
                        participants: res.data.participants || '',
                        bidOpeningTime: res.data.bidOpeningTime || '',
                        submitType: res.data.submitType || 0,
                        content: res.data.content || ''
                    }
                } else {
                    this.$message.error(res.msg || '获取开标记录失败')
                }
            }).catch(error => {
                console.error('获取开标记录失败:', error)
                this.$message.error('获取开标记录失败，请重试')
            }).finally(() => {
                this.loading = false
            })
        },
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return ''
            // 将 ISO 格式转换为可读格式
            const date = new Date(dateTime)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}`
        },
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 签名
        handleSign() {
            this.$confirm('确认签名后将无法修改，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.signNot()

            }).catch(() => {
                this.$message.info('已取消签名')
            })
        },
        //签字
        signNot() {
            signNot(this.sectionCode).then(res => {
                if (res.code === 200 && res.data) {
                    this.$message.success('签名成功')
                    this.getSignNot()
                }
            }).catch(() => {
                this.$message.error('投标人签字失败')
            }).finally(() => {
                this.loading = false
            })

        },
        //查询投标人是否签字
        getSignNot() {
            getSignNot(this.sectionCode).then(res => {
                if (res.code === 200) {
                    if (res.data == 1) {
                        this.signed = true
                    }else{
                        this.signed = false
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.$message.error('查询投标人是否签字失败')
            }).finally(() => {
                this.loading = false
            })


        }

    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    overflow-x: hidden;
}

// 开标记录头部信息
.record-header {
    margin-bottom: 24px;
    padding: 20px;
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 8px;

    .header-item {
        margin-bottom: 12px;
        line-height: 1.8;
        display: flex;
        align-items: center;

        &:last-child {
            margin-bottom: 0;
        }

        .label {
            font-weight: 600;
            color: @gray-600;
            margin-right: 10px;
            font-size: 14px;
            min-width: 100px;
        }

        .value {
            color: @gray-700;
            font-size: 14px;
        }
    }
}

// 开标记录内容
.record-content {
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border: 1px solid @gray-200;
    border-radius: 8px;

    .content-html {
        color: @gray-700;
        line-height: 1.8;
        font-size: 14px;

        // 富文本内容样式
        /deep/ p {
            margin: 10px 0;
            line-height: 1.8;
        }

        /deep/ table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;

            th,
            td {
                border: 1px solid @gray-200;
                padding: 12px 15px;
                text-align: left;
            }

            th {
                background: @gray-50;
                font-weight: 600;
                color: @gray-700;
            }

            td {
                color: @gray-600;
            }

            tr:hover {
                background: @gray-50;
            }
        }

        /deep/ h1,
        /deep/ h2,
        /deep/ h3,
        /deep/ h4,
        /deep/ h5,
        /deep/ h6 {
            margin: 15px 0 10px 0;
            color: @gray-700;
            font-weight: 600;
        }
    }
}

// 签名区域
.signature-section {
    margin-top: 24px;
    padding: 24px;
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 8px;
    text-align: center;

    .signature-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin-bottom: 20px;
    }

    .signature-box {
        min-height: 120px;
        background: #fff;
        border: 2px dashed @gray-300;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .unsigned-area {
            text-align: center;
            color: @gray-500;

            i {
                font-size: 48px;
                margin-bottom: 10px;
                display: block;
            }

            p {
                margin: 0;
                font-size: 14px;
            }
        }

        .signed-area {
            text-align: center;
            color: @success-color;

            i {
                font-size: 48px;
                margin-bottom: 10px;
                display: block;
            }

            p {
                margin: 0;
                font-size: 14px;
                font-weight: 600;
            }
        }
    }

    .signature-button {
        .el-button {
            padding: 12px 50px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 4px;

            &:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
        }
    }
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }

    .record-header .header-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .signature-section {
        padding: 16px;
    }
}
</style>